import React, { Fragment, useEffect, useRef, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { LogoutUserAction } from "../../redux/actions/userActions";
import Avatar from "../images/avatar.png";
import Sort from "../images/sort.png";
import Sidebar from "./Sidebar";

const Home = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const headerRef = useRef(null);

  const { isLoggedout, user, isAuthenticated } = useSelector(
    (state) => state.verifyEmailStore
  );

  const [showHeader, setShowHeader] = useState(false);

  const logoutUser = () => {
    dispatch(LogoutUserAction());
  };

  useEffect(() => {
    if (isLoggedout) {
      localStorage.setItem("email", "");
      navigate("/login");
    }
    if (isAuthenticated && user?.role === "Admin") {
      navigate("/admin");
    }
  }, [isLoggedout, navigate, isAuthenticated, user]);

  const handleClick = () => {
    setShowHeader(false);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (headerRef.current && !headerRef.current.contains(event.target)) {
        setShowHeader(false);
      }
    }

    if (showHeader) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showHeader]);

  return (
    <Fragment>
      {user?.role === 'Unauthorized' ? (
        <section className="w-[100%] h-[100vh] flex-center">
          <div className="p-[3vmax] flex-center flex-col w-[90%] lg:w-[60%] bg-white shadow-1">
            <h2 className="text-[2.5vmax] font-bold font-2">🚫 Unauthorized Access</h2>
            <br />
            <p className="text-center">
              This platform is restricted to admin use only. Unauthorized users are not permitted. If you are a Product Manager or Inventory Manager, please contact the admin to request access.
            </p>
            <br />
            <button
              className="bg-[image:var(--gradient)] text-white font-bold py-[0.8vmax] px-[2vmax] rounded-[2vmax] mt-[1vmax]"
              onClick={logoutUser}
            >
              Logout
            </button>
          </div>
        </section>
      ) : (
        <section className="flex justify-between">
          <Sidebar
            user={user}
            headerRef={headerRef}
            showHeader={showHeader}
            logoutUser={logoutUser}
            handleClick={handleClick}
          />

          {/* Main Content */}
          <div className="w-[100%] transition-all duration-300">
            <div className="w-[100%] fixed top-0 right-0 py-[1vmax] pl-[1.5vmax] pr-[1.5vmax] lg:pr-[2.5vmax] transition-all duration-300 z-[100] bg-[var(--color-1)]">
              <div className="bg-white rounded-[1vmax] shadow-1 flex justify-between items-center min-h-[4vmax]">
                <button
                  className="ml-[1vmax] flex-shrink-0 hover:translate-x-2 transition-transform duration-200"
                  onClick={() => setShowHeader((prev) => !prev)}
                >
                  <img src={Sort} alt="" className="w-[3vmax] lg:w-[2vmax]" />
                </button>

                <div className="flex items-center gap-[1vmax] pr-[1vmax] flex-shrink-0">
                  <div className="flex items-center gap-[0.8vmax]">
                    <div className="w-[2.5vmax] h-[2.5vmax] rounded-full overflow-hidden flex-shrink-0">
                      <img
                        src={user?.avatar_url || Avatar}
                        alt=""
                        className="w-[2.5vmax] h-[2.5vmax] object-cover"
                      />
                    </div>
                    <div className="flex flex-col min-w-0">
                      <h3 className="text-[1.6vmax] lg:text-[1vmax] font-3 font-bold leading-tight whitespace-nowrap">{user?.name}</h3>
                      <span className="text-[1.3vmax] lg:text-[0.75vmax] text-slate-500 whitespace-nowrap">{user?.role}</span>
                    </div>
                  </div>
                  <button
                    onClick={logoutUser}
                    title="Logout"
                    className="w-[3vmax] h-[3vmax] lg:w-[2vmax] lg:h-[2vmax] rounded-lg bg-red-50 hover:bg-red-100 text-red-500 flex items-center justify-center transition-colors flex-shrink-0"
                  >
                    <i className="fa-solid fa-arrow-right-from-bracket text-[1.2vmax] lg:text-[0.85vmax]" />
                  </button>
                </div>
              </div>
            </div>

            <div className="pb-[9vmax] lg:pb-[7vmax]"></div>
            <Outlet />
          </div>
        </section>
      )}
    </Fragment>
  );
};

export default Home;
